var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"post"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showPost == false)?_c('RingLoader',{attrs:{"color":this.spinnerColor,"size":this.spinnerSize}}):_vm._e()],1),_vm._v(" "),(_vm.showPost == true)?_c('Post',{attrs:{"fullPost":this.post}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc9b4a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostPage.vue
// module id = null
// module chunks = 